import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { ParagraphPresentation } from '../Paragraph/ParagraphPresentation.js';

var defaultProps = {
  onChange: function onChange() {
    /* empty */
  },
  onMouseHoverChange: function onMouseHoverChange() {
    /* empty */
  },
  onKeyboardFocusChange: function onKeyboardFocusChange() {
    /* empty */
  }
};
var TogglePresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2;
  var id = props.id,
    className = props.className,
    children = props.children,
    noMargin = props.noMargin,
    isStencilHost = props.isStencilHost,
    value = props.value,
    indeterminate = props.indeterminate,
    disabled = props.disabled,
    hasKeyboardFocus = props.hasKeyboardFocus,
    hasMouseHover = props.hasMouseHover,
    invalid = props.invalid,
    htmlAttrs = props.htmlAttrs,
    label = props.label,
    helperText = props.helperText,
    errorText = props.errorText,
    title = props.title,
    _onChange = props.onChange,
    name = props.name,
    onKeyboardFocusChange = props.onKeyboardFocusChange,
    onMouseHoverChange = props.onMouseHoverChange,
    type = props.type,
    hostClass = props.hostClass;
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    isStencilHost: isStencilHost
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-container"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__checked"), value || indeterminate), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__disabled"), disabled), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__hover"), !disabled && (hasMouseHover || hasKeyboardFocus)), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__focus"), !disabled && hasKeyboardFocus), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__invalid"), invalid || errorText), _cleanupClassObject2))
  }, /*#__PURE__*/React.createElement("input", Object.assign({}, htmlAttrs, {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "-input"), true)),
    id: id,
    type: type,
    disabled: disabled,
    checked: value,
    title: title,
    onChange: function onChange(e) {
      e.stopPropagation();
      _onChange(e.target.checked, name, e);
    },
    onFocus: function onFocus() {
      if (document.documentElement.getAttribute("data-whatinput") === "keyboard") {
        onKeyboardFocusChange(true);
      }
    },
    onBlur: function onBlur() {
      return onKeyboardFocusChange(false);
    },
    onMouseEnter: function onMouseEnter() {
      if (document.documentElement.getAttribute("data-whatintent") === "mouse") {
        onMouseHoverChange(true);
      }
    },
    onMouseLeave: function onMouseLeave() {
      return onMouseHoverChange(false);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-background")
  }, children || /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-knob")
  })), (helperText || errorText || label) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-text")
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "".concat(hostClass, "-label"),
    htmlFor: id,
    onMouseEnter: function onMouseEnter() {
      if (document.documentElement.getAttribute("data-whatintent") === "mouse") {
        onMouseHoverChange(true);
      }
    },
    onMouseLeave: function onMouseLeave() {
      return onMouseHoverChange(false);
    }
  }, label), (helperText || errorText) && /*#__PURE__*/React.createElement(ParagraphPresentation, {
    className: "".concat(hostClass, "-helper-text"),
    size: invalid || errorText ? "error-text" : "helper-text"
  }, errorText || helperText))));
}, defaultProps);
TogglePresentation.displayName = "TogglePresentation";

export { TogglePresentation, defaultProps };
